<template>
	<div class="content">
		<div class="section">
			<div class="section-tit">계약 설정</div>
			<div class="tab-btn">
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'tpl' }" @click="tab = 'tpl'">
					기본 체크리스트
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'code' }" @click="tab = 'code'">
					역할 · 작업구분
				</button>
				<button type="button" class="btn tab" v-bind:class="{ active: tab === 'cfg' }" @click="tab = 'cfg'">
					알림 설정
				</button>
			</div>

			<!-- 기본 체크리스트 템플릿 -->
			<div class="tab-con" v-if="tab === 'tpl'">
				<div class="txt-c--grey mb-1">
					※ 여기 등록된 항목이 <b>계약 등록 시 자동으로 체크리스트에 복사</b>됩니다.
					이미 등록된 계약의 체크리스트는 바뀌지 않습니다(계약별로 추가 · 삭제하세요).
				</div>
				<div class="table-wrap">
					<table class="table">
						<colgroup>
							<col width="10%" /><col width="8%" /><col width="46%" /><col width="12%" /><col width="24%" />
						</colgroup>
						<tr>
							<th>순서</th>
							<th>번호</th>
							<th>항목명</th>
							<th>사용</th>
							<th>관리</th>
						</tr>
						<tr v-for="(t, idx) in tplList" :key="'tpl_' + t.tpl_uid">
							<td>
								<button type="button" class="btn sort" v-if="idx != 0" @click="btnTplOrder(tplList[idx - 1].tpl_uid, t.tpl_uid)">
									<b-icon-arrow-up />
								</button>
								<button
									type="button"
									class="btn sort"
									v-if="idx + 1 != tplList.length"
									@click="btnTplOrder(t.tpl_uid, tplList[idx + 1].tpl_uid)"
								>
									<b-icon-arrow-down />
								</button>
							</td>
							<td>{{ idx + 1 }}</td>
							<td><input type="text" class="form-control sm" v-model="t.name" maxlength="100" /></td>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" :true-value="'Y'" :false-value="'N'" v-model="t.use_flag" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>
								<button type="button" class="btn btn-xsm btn-secondary" @click="btnTplUpdate(t)">저장</button>
								<button type="button" class="btn btn-xsm btn-danger m-l--1" @click="btnTplDelete(t)">삭제</button>
							</td>
						</tr>
						<tr>
							<td colspan="2">추가</td>
							<td><input type="text" class="form-control sm" v-model="tplAdd" placeholder="항목명" @keyup.enter="btnTplAdd" /></td>
							<td colspan="2">
								<button type="button" class="btn btn-xsm btn-primary" @click="btnTplAdd">추가</button>
							</td>
						</tr>
					</table>
				</div>
			</div>

			<!-- 역할 · 작업구분 코드 (조회 전용 — 코드 편집은 직원코드관리와 같은 ind_cfg 편집 경로를 쓰지 않는다) -->
			<div class="tab-con" v-else-if="tab === 'code'">
				<div class="txt-c--grey mb-1">
					※ 계약 참여자 역할과 작업내역 구분 목록입니다. 항목 추가 · 변경이 필요하면 개발팀에 요청하세요.
				</div>
				<div class="row">
					<div class="col-6">
						<div class="section-tit sub">참여자 역할</div>
						<div class="table-wrap">
							<table class="table">
								<tr>
									<th>번호</th>
									<th>역할</th>
								</tr>
								<tr v-for="(r, i) in roleList" :key="'rl_' + r.ind_cfg_uid">
									<td>{{ i + 1 }}</td>
									<td>{{ r.name }}</td>
								</tr>
							</table>
						</div>
					</div>
					<div class="col-6">
						<div class="section-tit sub">작업내역 구분</div>
						<div class="table-wrap">
							<table class="table">
								<tr>
									<th>번호</th>
									<th>구분</th>
								</tr>
								<tr v-for="(t, i) in logTypeList" :key="'lt_' + t.ind_cfg_uid">
									<td>{{ i + 1 }}</td>
									<td>{{ t.name }}</td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>

			<!-- 알림 배치 -->
			<div class="tab-con" v-else>
				<div class="txt-c--grey mb-1">
					※ 잔금일 D-30 / D-14 / D-7 / D-1 알림과 담당 체크리스트 미완료 알림은 매일 정해진 시각에
					쪽지로 자동 발송됩니다(같은 건은 하루 한 번만 발송).
				</div>
				<table class="table type2">
					<colgroup>
						<col width="30%" /><col width="70%" />
					</colgroup>
					<tr>
						<th>알림 발송 시각</th>
						<td>
							매일
							<input
								type="number"
								class="form-control xsm"
								min="0"
								max="23"
								v-model="cfg.notify_hour.value"
								:disabled="!isMaster"
							/>
							시 (0~23)
							<button
								type="button"
								class="btn btn-xsm btn-secondary m-l--1"
								v-if="isMaster"
								@click="saveCfg('notify_hour')"
							>
								저장
							</button>
						</td>
					</tr>
					<tr>
						<th>미완료 체크리스트 알림</th>
						<td>
							잔금일
							<input
								type="number"
								class="form-control xsm"
								min="0"
								v-model="cfg.chk_pending_dday.value"
								:disabled="!isMaster"
							/>
							일 전 시점에 미완료 항목 담당자에게 발송
							<button
								type="button"
								class="btn btn-xsm btn-secondary m-l--1"
								v-if="isMaster"
								@click="saveCfg('chk_pending_dday')"
							>
								저장
							</button>
						</td>
					</tr>
					<tr>
						<th>수동 실행</th>
						<td>
							<button type="button" class="btn btn-sm btn-secondary" @click="btnRunNotify" :disabled="running || !isMaster">
								{{ running ? '실행중…' : '지금 한 번 실행' }}
							</button>
							<span class="txt-c--grey m-l--1">
								서버가 발송 시각에 내려가 있었던 날의 복구용입니다. 중복 발송은 자동으로 차단됩니다.
							</span>
							<div v-if="runResult" class="mt-1">
								대상 계약 {{ runResult.contracts }}건 / 잔금일 알림 {{ runResult.dday }}건 /
								미완료 알림 {{ runResult.pending }}건 / 쪽지 {{ runResult.sent }}통
								<span v-if="runResult.errors > 0" class="txt-c--red">/ 오류 {{ runResult.errors }}건</span>
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'SystemAdmin15',
	data() {
		return {
			tab: 'tpl',
			tplList: [],
			tplAdd: '',
			roleList: [],
			logTypeList: [],
			running: false,
			runResult: null,
			isMaster: false,
			// 설정 행이 없어도 템플릿이 터지지 않게 uid=null 기본 객체를 둔다.
			cfg: {
				notify_hour: { uid: null, value: '' },
				chk_pending_dday: { uid: null, value: '' },
			},
		};
	},
	created() {
		this.getTplList();
		this.getCodes();
		this.getCfg();
	},
	methods: {
		getTplList() {
			this.$apiGET('/admin/api/contract/template?all=Y').then(re => {
				if (Array.isArray(re)) this.tplList = re;
			});
		},
		getCodes() {
			this.$apiGET('/admin/api/contract/code?part=role').then(re => {
				if (Array.isArray(re)) this.roleList = re;
			});
			this.$apiGET('/admin/api/contract/code?part=log_type').then(re => {
				if (Array.isArray(re)) this.logTypeList = re;
			});
		},
		btnTplAdd() {
			if (!this.tplAdd || !this.tplAdd.trim()) {
				alert('항목명을 입력하세요.');
				return;
			}
			this.$apiPOST('/admin/api/contract/template/add', { name: this.tplAdd.trim() }).then(re => {
				if (re === false || !re || re.ok !== true) return;
				this.tplAdd = '';
				this.getTplList();
			});
		},
		btnTplUpdate(t) {
			if (!t.name || !t.name.trim()) {
				alert('항목명을 입력하세요.');
				return;
			}
			this.$apiPOST('/admin/api/contract/template/update', {
				tplUid: t.tpl_uid,
				name: t.name.trim(),
				use_flag: t.use_flag,
			}).then(re => {
				if (re !== true) return;
				this.getTplList();
			});
		},
		btnTplDelete(t) {
			if (!confirm(`"${t.name}" 항목을 삭제하시겠습니까? 이미 등록된 계약의 체크리스트는 그대로 남습니다.`)) return;
			this.$apiPOST('/admin/api/contract/template/delete', { tplUid: t.tpl_uid }).then(re => {
				if (re !== true) return;
				this.getTplList();
			});
		},
		btnTplOrder(u1, u2) {
			this.$apiPOST('/admin/api/contract/template/order', { uid_1: u1, uid_2: u2 }).then(re => {
				if (re !== true) return;
				this.getTplList();
			});
		},
		getCfg() {
			this.$apiGET('/admin/api/contract/config').then(re => {
				if (!re || !re.config) return;
				this.isMaster = !!(re.scope && re.scope.isMaster);
				re.config.forEach(c => {
					if (this.cfg[c.key]) this.cfg[c.key] = { uid: c.ind_cfg_uid, value: c.value };
				});
			});
		},
		saveCfg(key) {
			const c = this.cfg[key];
			if (!c || !c.uid) {
				alert('설정 항목을 찾을 수 없습니다.');
				return;
			}
			this.$apiPOST('/admin/api/contract/config/update', { uid: c.uid, val: String(c.value) }).then(re => {
				if (re !== true) return;
				this.getCfg();
			});
		},
		btnRunNotify() {
			if (!confirm('계약 알림 배치를 지금 실행하시겠습니까?')) return;
			this.running = true;
			this.$apiPOST('/admin/api/contract/notify/run', {}).then(re => {
				this.running = false;
				if (re === false || !re || re.ok !== true) return;
				this.runResult = {
					contracts: re.contracts || 0,
					dday: re.dday || 0,
					pending: re.pending || 0,
					sent: re.sent || 0,
					errors: re.errors || 0,
				};
			});
		},
	},
};
</script>

<style></style>
